import axios from 'axios';

//gate_permit
const ep_update_container  = `${process.env.VUE_APP_PB_API}/ags/gate_permit/update_container`;
const ep_get_detail_qr  = `${process.env.VUE_APP_PB_API}/ags/gate_permit/get_detail`;
//dashboard
const ep_get_expired_info  = `${process.env.VUE_APP_PB_API}/ags/dashboard/expired_lists`;
const ep_get_in_out_info  = `${process.env.VUE_APP_PB_API}/ags/dashboard/in_out`;
const ep_get_expired_excel  = `${process.env.VUE_APP_PB_API}/ags/dashboard/expired_lists/excel`;
const ep_get_truck_intensity_excel  = `${process.env.VUE_APP_PB_API}/ags/dashboard/truck_intensity/excel`;
const ep_today_in_out  = `${process.env.VUE_APP_PB_API}/ags/dashboard/today_in_out`;
const ep_member_count  = `${process.env.VUE_APP_PB_API}/ags/dashboard/member_count`;
const ep_monthly_overview  = `${process.env.VUE_APP_PB_API}/ags/dashboard/monthly_overview`;
const ep_daily_activity  = `${process.env.VUE_APP_PB_API}/ags/dashboard/daily_activity`;
const ep_weekly_heatmap  = `${process.env.VUE_APP_PB_API}/ags/dashboard/weekly_heatmap`;
const ep_activity_logs  = `${process.env.VUE_APP_PB_API}/ags/dashboard/activity_logs`;
const ep_get_frequent_trucking = `${process.env.VUE_APP_PB_API}/ags/dashboard/frequent_trucking`;
const ep_all_frequent_trucking = `${process.env.VUE_APP_PB_API}/ags/dashboard/frequent_trucking_all`;
//vehicle
const ep_index_mutation  = `${process.env.VUE_APP_PB_API}/ags/vehicle/index_mutation`;
const ep_add_mutation  = `${process.env.VUE_APP_PB_API}/ags/vehicle/add_mutation`;
const ep_del_mutation  = `${process.env.VUE_APP_PB_API}/ags/vehicle/del_mutation`;
//rfid
const ep_list_tag = `${process.env.VUE_APP_PB_API}/ags/rfid/list_tag`;
const ep_register_tag = `${process.env.VUE_APP_PB_API}/ags/rfid/register_tag`;

// gate_permit
// const listPermit_pb = (data) => {
//     let config = {
//         method: 'post',
//         maxBodyLength: Infinity,
//         url: ep_update_container,
//         headers: {
//             'Content-Type': 'application/json'
//         },
//         data: JSON.stringify(data),
//     }

//     return axios.request(config)
//         .then((response) => JSON.stringify(response.data))
//         .catch((error) => JSON.stringify(error));
// }

const updateContainer = (data) => {
    console.log(data);
    let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: ep_update_container,
        headers: {
            'Content-Type': 'application/json'
        },
        data: JSON.stringify(data),
    }

    return axios.request(config)
        .then((response) => JSON.stringify(response.data))
        .catch((error) => JSON.stringify(error));

}

const getDetailQR = (data) => {
    console.log(data);
    let config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: `${ep_get_detail_qr}/${data}`,
        headers: {
            'Content-Type': 'application/json'
        },
    }

    return axios.request(config)
        .then((response) => JSON.stringify(response.data))
        .catch((error) => JSON.stringify(error));
}

// Dashboard
const getExpiredInfo = () => {
    let config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: `${ep_get_expired_info}`,
        headers: {
            'Content-Type': 'application/json'
        },
    }

    return axios.request(config)
        .then((response) => JSON.stringify(response.data))
        .catch((error) => JSON.stringify(error));
}

const getInOutInfo = () => {
    let config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: `${ep_get_in_out_info}`,
        headers: {
            'Content-Type': 'application/json'
        },
    }

    return axios.request(config)
        .then((response) => JSON.stringify(response.data))
        .catch((error) => JSON.stringify(error));
}

const downloadExpLists = () => {
    axios.get(`${ep_get_expired_excel}`, {
        file_name: 'expired_lists'
    }, {
        responseType: 'blob'
    }).then((response) => {
        const url = URL.createObjectURL(new Blob([response.data], {
            type: 'application/vnd.ms-excel'
        }))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'expired_lists')
        document.body.appendChild(link)
        link.click()
    });
}

const downloadTruckIntensity = (data) => {
    axios.post(`${ep_get_truck_intensity_excel}`, data, {
        responseType: 'blob',
        // responseType: 'application/json',
    }).then((response) => {
        console.log(response)
        const url = URL.createObjectURL(new Blob([response.data], {
            type: 'application/vnd.ms-excel'
        }))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'truck_intensity')
        document.body.appendChild(link)
        link.click()
    });
}

//vehicle
const indexMutation = (data) => {
    let config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: `${ep_index_mutation}/${data.no_pol}`,
        headers: {
            'Content-Type': 'application/json'
        },
    }

    return axios.request(config)
        .then((response) => JSON.stringify(response.data))
        .catch((error) => JSON.stringify(error));
}

const addMutation = (data) => {
    // console.log(data);
    let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: ep_add_mutation,
        headers: {
            'Content-Type': 'application/json'
        },
        data: JSON.stringify(data),
    }

    return axios.request(config)
        .then((response) => JSON.stringify(response.data))
        .catch((error) => JSON.stringify(error));
}

const delMutation = (data) => {
    console.log('vhc',data);
    let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: ep_del_mutation,
        headers: {
            'Content-Type': 'application/json'
        },
        data: JSON.stringify(data),
    }

    return axios.request(config)
        .then((response) => JSON.stringify(response.data))
        .catch((error) => JSON.stringify(error));
}

const listTag = () => {
    let config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: ep_list_tag,
        headers: {
            'Content-Type': 'application/json'
        },
    }

    return axios.request(config)
        .then((response) => JSON.stringify(response.data))
        .catch((error) => JSON.stringify(error));
}

const registerTag = (data) => {
    console.log('regTag payload: ',data);
    let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: ep_register_tag,
        headers: {
            'Content-Type': 'application/json'
        },
        data: JSON.stringify(data),
    }

    return axios.request(config)
        .then((response) => JSON.stringify(response.data))
        .catch((error) => JSON.stringify(error));
}

const monthlyOverview = () => {
    let config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: `${ep_monthly_overview}`,
        headers: {
            'Content-Type': 'application/json'
        },
    }

    return axios.request(config)
        .then((response) => JSON.stringify(response.data))
        .catch((error) => JSON.stringify(error));
}

const dailyActivity = (period) => {
    const periodParam = period ? `?period=${period}` : '';
    let config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: `${ep_daily_activity}${periodParam}`,
        headers: {
            'Content-Type': 'application/json'
        },
    }

    return axios.request(config)
        .then((response) => JSON.stringify(response.data))
        .catch((error) => JSON.stringify(error));
}

const weeklyHeatmap = (mark = null) => {
    let markParam = mark ? `?mark=${mark}` : '';
    let config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: `${ep_weekly_heatmap}${markParam}`,
        headers: {
            'Content-Type': 'application/json'
        },
    }

    return axios.request(config)
        .then((response) => JSON.stringify(response.data))
        .catch((error) => JSON.stringify(error));
}

const todayInOut = () => {
    let config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: `${ep_today_in_out}`,
        headers: {
            'Content-Type': 'application/json'
        },
    }

    return axios.request(config)
        .then((response) => JSON.stringify(response.data))
        .catch((error) => JSON.stringify(error));
}

const memberCount = (id) => {
    let config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: `${ep_member_count}/${id}`,
        headers: {
            'Content-Type': 'application/json'
        },
    }

    return axios.request(config)
        .then((response) => JSON.stringify(response.data))
        .catch((error) => JSON.stringify(error));
}

const activityLogs = () => {
    let config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: `${ep_activity_logs}`,
        headers: {
            'Content-Type': 'application/json'
        },
    }

    return axios.request(config)
        .then((response) => JSON.stringify(response.data))
        .catch((error) => JSON.stringify(error));
}

const getFrequentlyTrucking = (month = null, year = null) => {
    let config = {
        method: 'get',
        params: {
            month,
            year
        },
        maxBodyLength: Infinity,
        url: `${ep_get_frequent_trucking}`,
        headers: {
            'Content-Type': 'application/json'
        },
    }

    return axios.request(config)
        .then((response) => JSON.stringify(response.data))
        .catch((error) => JSON.stringify(error));
}

const allFrequentlyTrucking = (month = null, year = null, paginate, search = null) => {
    const keyword = (search !== null && search !== '') ? `&search=${search}` : '';
    let config = {
        method: 'get',
        params: {
            month,
            year
        },
        maxBodyLength: Infinity,
        url: `${ep_all_frequent_trucking}?page=${paginate.current_page}${keyword}`,
        headers: {
            'Content-Type': 'application/json'
        },
    }

    return axios.request(config)
        .then((response) => JSON.stringify(response.data))
        .catch((error) => JSON.stringify(error));
}

export { 
    getFrequentlyTrucking, allFrequentlyTrucking,
    todayInOut, memberCount,
    monthlyOverview, dailyActivity, weeklyHeatmap, activityLogs,
    updateContainer, getDetailQR, 
    getExpiredInfo, getInOutInfo, downloadExpLists, downloadTruckIntensity,
    indexMutation, addMutation, delMutation,
    listTag, registerTag
}
